import NewsTicker from "./NewsTicker";

export default NewsTicker;
